export default {
  navAriaLabel: {
    id: 'a11y_navigation_menu_aria_label',
    defaultMessage: 'Skip to content menu',
  },
  skipToASectionTitle: {
    id: 'a11y_navigation_menu_skip_to_a_section',
    defaultMessage: 'Skip to a section',
  },
  goToAPageTitle: {
    id: 'a11y_navigation_menu_go_to_a_page',
    defaultMessage: 'Go to a page',
  },
  showHideShortcuts: {
    id: 'a11y_navigation_menu_shortcut_show_hide',
    defaultMessage: 'Show / hide keyboard shortcuts',
  },
  navigationHelp: {
    id: 'a11y_navigation_menu_navigation_help',
    defaultMessage: 'Navigate with up/down arrow keys',
  },
}
